// ** Toolkit imports
import { configureStore } from "@reduxjs/toolkit";

// ** Reducers
import auth from "../store/auth/index";
import sidebarReducer from "../store/sidebar";
import dashboardReducer from "../store/dashboard/index";
import userReducer from "./user2";


export const store = configureStore({
  reducer: {
    auth,
    sidebarReducer,
    dashboardReducer,
    users: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
